<template>
  <div>
    <img :src="imageMap.spinner" alt="" class="spinner">
    <div class="text">
      正在查询
    </div>
    <div class="noticeBoard">
      <div class="notice">
        您只能查询到经由权威媒体发布的新冠肺炎感染者的行程，<!--
        -->如未查询到行程信息并不代表一定没有与新冠肺炎病毒感染者同程，<!--
        -->如出现症状请就近到指定发热门诊救治。
      </div>
      <div class="notice">
        数据错误或问题反馈：zhoumh@133.cn、luxx@133.cn
      </div>
    </div>
  </div>
</template>

<script>
  import imageMap from '../../image-map.js';

  export default {
    data() {
      return { imageMap };
    }
  };
</script>

<style scoped lang="scss">
  @import "./loading.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/loading.vue